import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=3c50f7e1&scoped=true&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"
import style0 from "./Results.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Results.vue?vue&type=style&index=1&id=3c50f7e1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50f7e1",
  null
  
)

export default component.exports